import { MessageCircle, ShieldAlert, CalendarCheck } from "lucide-react";

const benefits = [
  {
    icon: MessageCircle,
    title: "Respuestas rápidas a dudas comunes",
    description:
      "Nuestro asistente responde al instante tus preguntas sobre vacunas, alimentación, síntomas y más.",
  },
  {
    icon: ShieldAlert,
    title: "Detección de urgencias y recomendaciones claras",
    description:
      "Identifica situaciones de urgencia y te indica los pasos a seguir para actuar con rapidez.",
  },
  {
    icon: CalendarCheck,
    title: "Solicitud de cita (recogida de datos)",
    description:
      "El asistente pide los datos mínimos (mascota, motivo, teléfono y disponibilidad) y deja una solicitud lista para que el equipo la confirme.",
  },
];

export const BenefitsSection = () => {
  return (
    <section
      data-testid="benefits-section"
      className="py-20 md:py-28 relative"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-14 md:mb-20">
          <span className="text-sm font-medium tracking-wide uppercase text-primary/80 mb-3 block">
            Beneficios
          </span>
          <h2
            data-testid="benefits-title"
            className="text-3xl md:text-4xl font-bold text-foreground tracking-tight"
          >
            Todo lo que necesitas, al alcance
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div
                key={index}
                data-testid={`benefit-card-${index}`}
                className="group bg-secondary/30 rounded-2xl p-8 border border-transparent hover:border-primary/10 hover:bg-secondary/50 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-5 group-hover:bg-primary/15 transition-colors">
                  <Icon
                    className="w-6 h-6 text-primary"
                    strokeWidth={1.5}
                  />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-3 tracking-tight">
                  {benefit.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
